import { Component, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DebtorDocumentTypeV2 } from 'src/app/_models';

@Component({
  selector: 'app-custom-country-phone-select-v2',
  templateUrl: './custom-country-phone-select-v2.component.html',
  styleUrls: ['./custom-country-phone-select-v2.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomCountryPhoneSelectV2Component),
      multi: true
    }
  ]
})
export class CustomCountryPhoneSelectV2Component implements ControlValueAccessor {

  @Input() options: DebtorDocumentTypeV2[] = [];
  @Input() placeholder: string = "";
  @Output() selectedOption = new EventEmitter<string>();
  @Input() version: 'V1' | 'V2' = 'V1';
  @Input() designVersion: 'V1' | 'V2' = 'V1';

  @Input() additionalFormControl: FormControl; // Nuevo FormControl
  @Output() setAdditionalFormControlValue = new EventEmitter<string>();


  private onChange: (value: any) => void = () => { };
  private onTouch: () => void = () => { };

  isOpen = false;
  selectedValue: DebtorDocumentTypeV2;

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  selectOption(option: DebtorDocumentTypeV2) {
    let valueChanged: string;

    this.selectedValue = option;
    valueChanged = option.id;

    this.isOpen = false;
    this.onChange(valueChanged);
    this.onTouch();
    this.selectedOption.emit(valueChanged);
  }

  writeValue(id: DebtorDocumentTypeV2['id']): void {
    this.selectedValue = this.options.find(el => id === el.id);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void { }


  numberOnly(event: KeyboardEvent): boolean {
    const key = event.key;
    // Permitir números del 0 al 9
    if (/\d/.test(key)) {
      return true;
    }
    return false;
  }

  onInput(event: any) {
    const value = (event.target as HTMLInputElement).value;
    this.setAdditionalFormControlValue.emit(value);
  }
}
